import React from "react";

const ProductIcon = ({ size = 20, className = "", ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_869_27758)">
        <rect x="3" y="2.5" width="18" height="5" rx="2" fill="currentColor"/>
        <circle cx="5.5" cy="5" r="0.5" fill="#262B30"/>
        <circle cx="7.5" cy="5" r="0.5" fill="#262B30"/>
        <g opacity="0.55">
          <rect x="3" y="9.5" width="18" height="5" rx="2" fill="currentColor"/>
          <circle cx="5.5" cy="12" r="0.5" fill="#262B30"/>
          <circle cx="7.5" cy="12" r="0.5" fill="#262B30"/>
        </g>
        <g opacity="0.3">
          <rect x="3" y="16.5" width="18" height="5" rx="2" fill="currentColor"/>
          <circle cx="5.5" cy="19" r="0.5" fill="#262B30"/>
          <circle cx="7.5" cy="19" r="0.5" fill="#262B30"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_869_27758">
          <rect width="24" height="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ProductIcon;
